import React, { useLayoutEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { Summary } from './Pages/Summary';
import { App as InvoicesEdit } from '../Billing/Pages/Invoices/Edit';
import { UpdateCreditCardApp as UpdateCreditCard } from '../Billing/Pages/UpdateCreditCard';
import { Subscription } from './Pages/Subscription';
import { RedeemCouponModal } from './Components/RedeemCouponModal';
import { App as CancelSubscription } from '../Billing/Pages/CancelSubscription';
import { Pricing } from './Pages/Pricing';
import { usePlasmicCMS } from '~/App/Api/Plasmic';
import { PlanCard, PlasmicModelType } from '~/types/models/plasmic';
import { Checkout } from './Pages/Checkout';

export enum BillingRouteTypes {
  Summary = 'summary',
  Pricing = 'pricing',
  Checkout = 'checkout',
  Subscription = 'subscription',
  InvoicesEdit = 'invoices_edit',
  UpdateCreditCard = 'update_credit_card',
  CancelSubscription = 'cancel_subscription',
}

export const billingRoutes: Record<BillingRouteTypes, string> = {
  [BillingRouteTypes.Summary]: '/billing',
  [BillingRouteTypes.Pricing]: '/billing/pricing',
  [BillingRouteTypes.Checkout]: '/billing/checkout/',
  [BillingRouteTypes.Subscription]: '/billing/subscription/:planSlug',
  [BillingRouteTypes.InvoicesEdit]: '/billing/invoices/edit',
  [BillingRouteTypes.UpdateCreditCard]: '/billing/cards/create',
  [BillingRouteTypes.CancelSubscription]:
    '/billing/subscriptions/cancel/:planSlug',
};

export default function NewBilling() {
  const location = useLocation();

  // Pre-load plan cards
  usePlasmicCMS<PlanCard>({
    model: PlasmicModelType.PlanCard,
    query: {
      category: 'pricing',
    },
  });

  // Scroll to top if path changes
  useLayoutEffect(() => {
    const element = document.getElementsByClassName('panel-settings');
    element[0].scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const targetElement = document.getElementById('bonjoro-app') as HTMLElement;
  return createPortal(
    <>
      <Switch>
        <Route exact path={billingRoutes.summary} component={Summary} />
        <Route path={`${billingRoutes.checkout}:type?`} component={Checkout} />
        <Route path={`${billingRoutes.pricing}/:select?`} component={Pricing} />
        <Route path={billingRoutes.subscription} component={Subscription} />
        <Route path={billingRoutes.invoices_edit} component={InvoicesEdit} />
        <Route
          path={billingRoutes.update_credit_card}
          component={UpdateCreditCard}
        />
        <Route
          path={billingRoutes.cancel_subscription}
          render={() => <CancelSubscription />}
        />
      </Switch>
      <RedeemCouponModal />
    </>,
    targetElement
  );
}
